/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {useAuth} from '../core/Auth'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {login} from './server/UpdateAccount'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'

const loginSchema = Yup.object().shape({
  username: Yup.string().required('Trường này bắt buộc'),
  password: Yup.string().min(6, 'Nhập ít nhất 6 kí tự').required('Trường này bắt buộc'),
})

const initialValues = {
  username: '',
  password: '',
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const history = useNavigate()
  let storeMe = {
    myBool: true,
  }

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const requestLogin = {
          username: values.username,
          password: values.password,
        }
        const auth = await login(requestLogin)
        if (auth.error_code === '0000') {
          setLoading(false)
          Swal.fire({
            title: auth.error_desc,
            // allowOutsideClick: false,
            icon: 'success',
            confirmButtonText: 'Okay',
          })

          localStorage.setItem('currentUser', JSON.stringify(storeMe))
          history('/open-account/auth/createQr')
        }
      } catch (error) {
        console.error(error)
        Swal.fire({
          title: 'Đăng nhập không thành công',
          // allowOutsideClick: false,
          icon: 'error',
          confirmButtonText: 'Thử lại',
        })
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  // useEffect(() => {
  //   window.location.reload()
  // }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundColor: 'rgb(235 243 243)',
      }}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <div className='mb-12'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/nhsv-logo-horizontal-light.svg')}
            className='h-45px'
          />
        </div>
        <div className='w-lg-1000px bg-body rounded shadow-sm p-lg-15 mx-auto card-container'>
          <form
            className='form w-100'
            onSubmit={formik.handleSubmit}
            noValidate
            id='kt_login_signin_form'
          >
            <div className='text-center mb-11'>
              <h1 className='text-dark fw-bolder mb-3'>Sign In</h1>
            </div>

            <div className='separator separator-content my-14'>
              <span className='w-125px text-gray-500 fw-semibold fs-7'>NHSV</span>
            </div>

            <div className='fv-row mb-8'>
              <label className='form-label fs-6 fw-bolder text-dark'>User name</label>
              <input
                placeholder='User name'
                {...formik.getFieldProps('username')}
                className={clsx(
                  'form-control bg-transparent',
                  {'is-invalid': formik.touched.username && formik.errors.username},
                  {
                    'is-valid': formik.touched.username && !formik.errors.username,
                  }
                )}
                type='text'
                name='username'
                autoComplete='off'
              />
              {formik.touched.username && formik.errors.username && (
                <div className='fv-plugins-message-container'>
                  <span className='text-danger' role='alert'>
                    {formik.errors.username}
                  </span>
                </div>
              )}
            </div>

            <div className='fv-row mb-3'>
              <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
              <input
                type='password'
                autoComplete='off'
                placeholder='Password'
                {...formik.getFieldProps('password')}
                className={clsx(
                  'form-control bg-transparent',
                  {
                    'is-invalid': formik.touched.password && formik.errors.password,
                  },
                  {
                    'is-valid': formik.touched.password && !formik.errors.password,
                  }
                )}
              />
              {formik.touched.password && formik.errors.password && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.password}</span>
                  </div>
                </div>
              )}
            </div>

            <div className='d-grid mb-10'>
              <button
                type='submit'
                id='kt_sign_in_submit'
                className='btn btn-primary mt-6'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {!loading && <span className='indicator-label'>Log in</span>}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
